import {createAction} from '@reduxjs/toolkit';
import {type FeatureRef} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

const actionPrefix = 'QUOTA_RESERVATIONS';

export const selectFeatures = createAction<FeatureRef[]>(
  `${actionPrefix}/SELECT_FEATURES`,
);

export const selectProduct = createAction<Product | null>(
  `${actionPrefix}/SELECT_PRODUCT`,
);
